<template>
  <div>
    <div v-for="(possibleAnswer, index) in possibleAnswers">
      <v-checkbox
        :label="possibleAnswer"
        v-model="answer"
        :value="index"
        :disabled="disabledAnswers"
        color="blue"
      ></v-checkbox>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'multiple-answer',
    props: [
      'possibleAnswers',
      'chosenAnswer',
      'disabledAnswers',
    ],
    data () {
      return {
        answer: []
      }
    },
    mounted() {
      this.answer = this.chosenAnswer
    },
    watch: {
      'answer': function () {
        this.$emit('updated', this.answer)
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/single/MultipleAnswer.vue